import React from 'react';
import { FaDatabase } from 'react-icons/fa';
import { SiPostgresql, SiMariadb } from 'react-icons/si';
import { BRAND } from 'Utils/styleTokens';

// Only logos we're confident shipping commercially. Add to this map as more brand
// assets clear review. Anything not in the map renders the generic database glyph.
const ENGINE_ICONS = {
  postgresql: <SiPostgresql color="#007bc6" />,
  mariadb: <SiMariadb color="#1D2E5B" />,
};

const GENERIC = <FaDatabase color={BRAND.blue} />;

/**
 * Renders a driver brand glyph. Looks up by `engine` first, then by `flavorId` (lowercased).
 * Falls back to a generic database icon when no curated logo is available.
 */
export default function DriverLogo({ engine, flavorId, size = 20 }) {
  const key = (engine || flavorId || '').toLowerCase();
  const icon = ENGINE_ICONS[key] || GENERIC;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', fontSize: size }}>
      {React.cloneElement(icon, { size })}
    </span>
  );
}
